export const getters = {
  masterFeatureList: (state) => state.masterFeatureList,
  masterTagList: (state) => state.masterTagList
};
